module.exports = __webpack_public_path__ + "img/ueber-mich_960.e6888360.webp";